if (!document.body.classList.contains('template-index')) {
  return; // disable cursor everywhere except homepage
}

document.addEventListener('DOMContentLoaded', () => {

  const ring = document.createElement('div');
  ring.classList.add('cursor-ring');
  document.body.appendChild(ring);

  let mouseX = 0, mouseY = 0;
  let ringX = 0, ringY = 0;

  const baseSize = 30;
  const hoverSize = 58;
  const magnetSize = 70;
  const smoothness = 0.25;

  let magnetTarget = null;

  /* Track Mouse */
  document.addEventListener("mousemove", (e) => {
    mouseX = e.clientX;
    mouseY = e.clientY;
    ring.style.opacity = "1";
  });

  /* Hide when leaving window */
  document.addEventListener("mouseleave", () => ring.style.opacity = "0");
  document.addEventListener("mouseenter", () => ring.style.opacity = "1");

  /* Animation Loop */
  function animate() {
    if (magnetTarget) {
      const rect = magnetTarget.getBoundingClientRect();
      const targetX = rect.left + rect.width / 2;
      const targetY = rect.top + rect.height / 2;

      // stronger pull effect
      ringX += (targetX - ringX) * 0.18;
      ringY += (targetY - ringY) * 0.18;
    } else {
      ringX += (mouseX - ringX) * smoothness;
      ringY += (mouseY - ringY) * smoothness;
    }

    const currentSize = parseFloat(ring.style.width) || baseSize;
    ring.style.transform = `translate(${ringX - currentSize/2}px, ${ringY - currentSize/2}px)`;

    requestAnimationFrame(animate);
  }
  animate();

  /* Magnetic Elements */
  document.querySelectorAll("a, button, .magnet").forEach(el => {

    el.classList.add("magnetic-hover");

    el.addEventListener("mouseenter", () => {
      magnetTarget = el;

      // Soft glow + warp
      ring.style.width = `${magnetSize}px`;
      ring.style.height = `${magnetSize}px`;
      ring.style.boxShadow = `0 0 18px rgba(255,255,255,0.45)`;
      ring.style.borderRadius = "45%";

      // Button micro-lift
      el.style.transform = "translateY(-3px)";
    });

    el.addEventListener("mouseleave", () => {
      magnetTarget = null;

      // Reset ring
      ring.style.width = `${baseSize}px`;
      ring.style.height = `${baseSize}px`;
      ring.style.boxShadow = "none";
      ring.style.borderRadius = "50%";

      // Reset button
      el.style.transform = "translateY(0)";
    });

  });

});
